<template>
  <a-modal 
    v-model:open="visible"
    :title="modalTitle"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirm-loading="confirmLoading"
    width="900px"
  >
    <a-form :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="ID">
            <a-input v-model:value="form.id" placeholder="知识库ID" disabled />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="名称" v-bind="validateInfos.name">
            <a-input v-model:value="form.name" placeholder="请输入知识库名称" />
          </a-form-item>
        </a-col>
      </a-row>
      
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="段落的最大数" v-bind="validateInfos.maxTokensPerParagraph">
            <a-input-number 
              v-model:value="form.maxTokensPerParagraph" 
              :min="1" 
              :max="10000"
              style="width: 100%"
              placeholder="段落的最大数"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="行最大数" v-bind="validateInfos.maxTokensPerLine">
            <a-input-number 
              v-model:value="form.maxTokensPerLine" 
              :min="1" 
              :max="1000"
              style="width: 100%"
              placeholder="每行的最大Token数"
            />
          </a-form-item>
        </a-col>
      </a-row>
      
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="段落重叠数" v-bind="validateInfos.overlappingTokens">
            <a-input-number 
              v-model:value="form.overlappingTokens" 
              :min="0" 
              :max="1000"
              style="width: 100%"
              placeholder="段落之间重叠的Token数"
            />
          </a-form-item>
        </a-col>
      </a-row>
      
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="知识库文档">
             
                      <FileUpload
        business="AIKmss"
        :keyValue=form.id
        sign="AIKmssDetailFlies"
        :accept="'.txt,.pdf,.md,.docx,.html,.doc,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.bmp,.webp,.svg'"
        :multiple="true"
        :max-count="30"
        @upload-success="beforeUploadSuccess"
        @upload-error="handleUploadError"
        @delete-success="handleRemoveFile"
        @file-ids-change="handleFileIdsChange"
      />
               
          </a-form-item>
        </a-col>
          <a-col :span="12">       
          <a-form-item label="矢量模型" v-bind="validateInfos.aIModelsId">
            <a-select 
              v-model:value="form.aIModelsId" 
              placeholder="请选择矢量化模型"
              :options="modelOptions"
              allow-clear
              show-search
              optionFilterProp="label"
            >
              <a-select-option 
                v-for="model in modelList" 
                :key="model.id" 
                :value="model.id"
              >
                {{ model.modelName }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Rerank模型" v-bind="validateInfos.aIRerankModelsId">
            <a-select 
              v-model:value="form.aIRerankModelsId" 
              placeholder="请选择Rerank重排模型"
              :options="rerankModelOptions"
              allow-clear
              show-search
              optionFilterProp="label"
            >
              <a-select-option 
                v-for="model in rerankModelList" 
                :key="model.id" 
                :value="model.id"
              >
                {{ model.modelName }}
              </a-select-option>
            </a-select>
          </a-form-item> </a-col>
      </a-row>
      
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="直接添加">
            <a-button @click="showAddContentModal" style="margin-right: 8px;">
              <EditOutlined />
              添加文本内容
            </a-button>
            <a-button @click="showAddUrlModal">
              <LinkOutlined />
              添加远程地址
            </a-button>
          </a-form-item>
        </a-col>
              <a-col :span="12">  </a-col>
      </a-row>
      
      <a-table 
        :columns="detailColumns" 
        :data-source="form.kmsDetailsList" 
        :pagination="false"
        row-key="id"
      >
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'fileName'">
            <template   v-if="record.contentName" > 
             <a   @click="getFileById(record.fileId,record.contentName)" >{{ record.contentName }}</a> 
            </template> 
            <template v-else>
              {{ record.content.substring(0, 30) + '...' }}
            </template>
          </template>
          <template v-else-if="column.key === 'fileType'">
            {{ record.fileType || 'Text' }}
          </template>
          <template v-else-if="column.key === 'status'">
            <a-tag :color="getStatusColor(record.status)">
              {{ getStatusText(record.status) }}
            </a-tag>
          </template>
          <template v-else-if="column.key === 'action'">
            <a-button type="link" @click="viewDetail(record)">查看</a-button>
            <a-popconfirm 
              
              title="确定要删除这条记录吗?" 
              @confirm="onDeleteDetail(index)"
            >
              <a-button type="link" danger>删除</a-button>
            </a-popconfirm>
          </template>
        </template>
      </a-table>
    </a-form>
    
    <!-- 添加文本内容模态框 -->
    <a-modal 
      v-model:open="contentModalVisible" 
      title="添加文本内容" 
      @ok="handleAddContent"
      @cancel="handleCancelContent"
      width="800px"
    >
      <a-form :model="contentForm">
        <a-form-item label="内容类型">
          <a-radio-group v-model:value="contentForm.type">
            <a-radio value="text">纯文本</a-radio>
            <a-radio value="markdown">Markdown</a-radio>
            <a-radio value="html">HTML</a-radio>
          </a-radio-group>
        </a-form-item>
            <a-form-item label="内容标题">
          <a-input 
            v-model:value="contentForm.contentName" 
            placeholder="例如：系统产品手册"
          />
        </a-form-item>
        <a-form-item label="文本内容">
          <a-textarea 
            v-model:value="contentForm.content" 
            :rows="15" 
            placeholder="请输入内容"
            :maxlength="50000"
            show-count
          />
        </a-form-item>
      </a-form>
    </a-modal>
    
    <!-- 添加远程地址模态框 -->
    <a-modal 
      v-model:open="urlModalVisible" 
      title="添加远程地址" 
      @ok="handleAddUrl"
      @cancel="handleCancelUrl"
      width="600px"
    >
      <a-form :model="urlForm">
        <a-form-item label="远程地址">
          <a-input 
            v-model:value="urlForm.url" 
            placeholder="请输入远程地址，例如：https://example.com/data.txt"
          />
        </a-form-item>
        <a-form-item label="内容类型">
          <a-select v-model:value="urlForm.type" placeholder="请选择内容类型">
            <a-select-option value="text">纯文本</a-select-option>
            <a-select-option value="markdown">Markdown</a-select-option>
            <a-select-option value="html">HTML</a-select-option>
            <a-select-option value="pdf">PDF</a-select-option>
            <a-select-option value="word">Word</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-modal>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, reactive, computed, watch, h } from 'vue';
import { Form, message, Modal } from 'ant-design-vue';
import { EditOutlined, LinkOutlined } from '@ant-design/icons-vue';
import { GetSnowflakeId } from '../../api/baseapi';
import FileUpload from '@/components/FileUpload.vue';
import {getFileById} from '../../api/file';
import { getAIModelsALLList } from '@/api/ai/aiModels';
const emit = defineEmits(['ok', 'cancel']);

const props = defineProps({
  open: {
    type: Boolean,
    default: false
  },
  knowledgeBaseData: {
    type: Object,
    default: () => ({})
  },
  modalType: {
    type: String,
    default: 'add' // 'add' 或 'edit'
  }
});

const useForm = Form.useForm;

const visible = ref(false);
const confirmLoading = ref(false); 

// 表单数据
const form = reactive({
  id: null,
  name: '',
  maxTokensPerParagraph: 299,
  maxTokensPerLine: 99,
  overlappingTokens: 49,
  kmsDetailsList: [],
  aIModelsId: undefined,
  aIRerankModelsId: undefined,
});

// 内容添加相关
const contentModalVisible = ref(false);
const contentForm = reactive({
  content: '',
  type: 'text',
  ContentName:'',
});

// URL添加相关
const urlModalVisible = ref(false);
const urlForm = reactive({
  url: '',
  type: 'text'
});

// 表单验证规则
const rules = reactive({
  name: [
    { required: true, message: '请输入知识库名称' }
  ],
  aIModelsId: [
    { required: true, message: '请选择矢量模型' }
  ],
  aIRerankModelsId: []
  });

// 表单验证
const { validate, validateInfos, resetFields } = useForm(form, rules);
const modelList = ref([]);
const rerankModelList = ref([]);
// 模型选项
const modelOptions = computed(() => {
  return modelList.value.map(model => ({
    label: model.modelName,
    value: model.id
  }));
});
// Rerank 模型选项
const rerankModelOptions = computed(() => {
  return rerankModelList.value.map(model => ({
    label: model.modelName,
    value: model.id
  }));
});
// 详情表格列
const detailColumns = [
  {
    title: '文件名',
    key: 'fileName',
    width: '30%'
  },
  {
    title: '文件类型',
    key: 'fileType',
    width: '20%'
  },
  {
    title: '状态',
    key: 'status',
    width: '20%'
  },
  {
    title: '操作',
    key: 'action',
    width: '30%'
  }
];

// 模态框标题
const modalTitle = computed(() => {
  return props.modalType === 'edit' ? '编辑知识库' : '添加知识库';
});

// 监听open属性变化
watch(() => props.open, async (newVal) => {
  visible.value = newVal;
  if (newVal) {
    // 重置表单
    resetFields(); 
    // 如果是编辑模式，填充表单数据
    if (props.modalType === 'edit' && props.knowledgeBaseData) {
      Object.keys(form).forEach(key => {
        if (props.knowledgeBaseData[key] !== undefined) {
          form[key] = props.knowledgeBaseData[key];
        }
      }); 
      // 处理详情列表
      if(props.knowledgeBaseData.aiKmssDetailsList) { 
        form.kmsDetailsList = [...props.knowledgeBaseData.aiKmssDetailsList];
      }
    } else {
      // 添加模式，设置默认值
      // 获取雪花ID并赋值给id字段
      try {
        const snowflakeId = await GetSnowflakeId();
        form.id = snowflakeId.data;
      } catch (error) {
        console.error('获取雪花ID失败:', error);
        form.id = null;
      }
      
      Object.assign(form, {
        name: '',
        maxTokensPerParagraph: 299,
        maxTokensPerLine: 99,
        overlappingTokens: 49,
        kmsDetailsList: []
      });
    }
  }
});

// 监听visible变化
watch(visible, (newVal) => {
  if (!newVal) {
    emit('cancel');
  }
});
// 加载模型列表
const loadModelList = async () => {
  try {
    const response = await getAIModelsALLList(2);
    if (response && response.code === 200 && response.data) {
      modelList.value = response.data;
    }
  } catch (error) {
    console.error('加载Embedding模型列表失败:', error);
  }
};

// 加载 Rerank 模型列表
const loadRerankModelList = async () => {
  try {
    const response = await getAIModelsALLList(4);
    if (response && response.code === 200 && response.data) {
      rerankModelList.value = response.data;
    }
  } catch (error) {
    console.error('加载Rerank模型列表失败:', error);
  }
};

loadModelList();
loadRerankModelList();
// 处理确认
const handleOk = async () => {
  try {
    await validate();
    
    confirmLoading.value = true;
    
    // 构造参数
    const params = {
      id: form.id,
      name: form.name,
      maxTokensPerParagraph: form.maxTokensPerParagraph,
      maxTokensPerLine: form.maxTokensPerLine,
      aIModelsId: form.aIModelsId,
      aIRerankModelsId: form.aIRerankModelsId,
      overlappingTokens: form.overlappingTokens,
      aIKmssDetailsList: form.kmsDetailsList
    };
    
    // 发送事件并等待父组件处理完成
    emit('ok', params, () => {
      // 回调函数：父组件完成操作后调用
      confirmLoading.value = false;
    });
  } catch (error) {
    console.log('表单验证失败:', error);
  }
};

// 处理取消
const handleCancel = () => {
  visible.value = false;
};

// 上传文件成功
const beforeUploadSuccess = (file) => {
  console.log('上传文件:', file);
  // 创建知识库详情对象
  const detailItem = {
    id: Date.now(),
    kmsId: form.id || 0,
    fileId: file.fileId,
    file: {
      fileName: file.fileName,
      size: file.fileSize
    },
    fileType: getFileType(file.fileName),
    content: "",
    url: "",
    dataCount: null,
    status: 0, // 0表示待处理
    errorMessage: ""
  };
  
  form.kmsDetailsList.push(detailItem);
  return false; // 返回false以阻止自动上传
};

// 显示添加文本内容模态框
const showAddContentModal = () => {
  contentForm.content = '';
  contentForm.type = 'text';
    contentForm.contentName = '';
  contentModalVisible.value = true;
};

// 处理添加文本内容
const handleAddContent = () => {
  if (!contentForm.content.trim()) {
    message.warning('请输入内容');
    return;
  }
   if (!contentForm.contentName.trim()) {
    message.warning('请输入内容标题名称');
    return;
  }
  
  // 创建知识库详情对象
  const detailItem = {
    id: Date.now(),
    kmsId: form.id || 0,
    fileId: null,
    file: null,
    fileType: contentForm.type,
    content: contentForm.content,
    contentName: contentForm.contentName,
    url: "",
    dataCount: null,
    status: 0, // 0表示待处理
    errorMessage: ""
  };
  
  form.kmsDetailsList.push(detailItem);
  contentModalVisible.value = false;
};

// 处理取消添加文本内容
const handleCancelContent = () => {
  contentModalVisible.value = false;
};

// 显示添加远程地址模态框
const showAddUrlModal = () => {
  urlForm.url = '';
  urlForm.type = 'text';
  urlModalVisible.value = true;
};

// 处理添加远程地址
const handleAddUrl = () => {
  if (!urlForm.url.trim()) {
    message.warning('请输入远程地址');
    return;
  }
  
  try {
    new URL(urlForm.url); // 验证URL格式
  } catch (e) {
    message.warning('请输入有效的URL地址');
    return;
  }
  
  // 创建知识库详情对象
  const detailItem = {
    id: Date.now(),
    kmsId: form.id || 0,
    fileId: null,
    file: null,
    fileType: urlForm.type,
    content: "",
    url: urlForm.url,
    dataCount: null,
    status: 0, // 0表示待处理
    errorMessage: ""
  };
  
  form.kmsDetailsList.push(detailItem);
  urlModalVisible.value = false;
};

// 处理取消添加远程地址
const handleCancelUrl = () => {
  urlModalVisible.value = false;
};

// 删除详情
const onDeleteDetail = (index) => {
  form.kmsDetailsList.splice(index, 1);
};

// 查看详情
const viewDetail = (record) => {
  let content;
  
  if (record.file) {
    // 如果是文件类型
    content = h('div', null, [
      h('p', null, ['文件名: ', h('strong', null, record.file.fileName)]),
      h('p', null, ['文件大小: ', h('strong', null, formatFileSize(record.file.size))]),
      h('p', null, ['文件类型: ', h('strong', null, record.fileType)]),
      h('p', null, ['状态: ', h('strong', null, getStatusText(record.status))])
    ]);
  } else if (record.url) {
    // 如果是URL类型
    content = h('div', null, [
      h('p', null, ['URL地址: ', h('strong', null, record.url)]),
      h('p', null, ['内容类型: ', h('strong', null, record.fileType)]),
      h('p', null, ['状态: ', h('strong', null, getStatusText(record.status))])
    ]);
  } else {
    // 如果是文本内容
    content = h('div', null, [
      h('p', null, ['内容标题: ', h('strong', null, record.contentName || '未设置')]),
      h('p', null, ['内容类型: ', h('strong', null, record.fileType)]),
      h('p', null, ['状态: ', h('strong', null, getStatusText(record.status))]),
      h('h4', null, '内容预览:'),
      h('div', { 
        style: 'max-height: 200px; overflow-y: auto; border: 1px solid #ddd; padding: 10px; white-space: pre-wrap;', 
        innerHTML: record.content
      })
    ]);
  }
  
  Modal.info({
    title: '详情信息',
    width: 600,
    content: content,
    okText: '关闭'
  });
};

// 格式化文件大小
const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// 获取文件类型
const getFileType = (fileName) => {
  const ext = fileName.split('.').pop()?.toLowerCase();
  if(['pdf'].includes(ext)) return 'PDF';
  if(['doc', 'docx'].includes(ext)) return 'Word';
  if(['xls', 'xlsx'].includes(ext)) return 'Excel';
  if(['txt'].includes(ext)) return 'Text';
  if(['md'].includes(ext)) return 'Markdown';
  if(['html', 'htm'].includes(ext)) return 'Html';
  if(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext)) return 'Image';
  return 'Other';
};

// 获取状态颜色
const getStatusColor = (status) => {
  switch(status) {
    case 0: return 'orange'; // 待处理 
    case 1: return 'green'; // 已完成
    case 2: return 'red'; // 失败
    default: return 'default';
  }
}; 
// 获取状态文本
const getStatusText = (status) => {
  switch(status) {
    case 0: return '待处理'; 
    case 1: return '已完成';
    case 2: return '失败';
    default: return '未知';
  }
};

// 删除上传文件
const handleRemoveFile = (file) => {
  const index = form.kmsDetailsList.findIndex(item => 
    item.file && item.file.fileName === file.name
  );
  if(index !== -1) {
    form.kmsDetailsList.splice(index, 1);
  }
};

// 处理文件ID变更
const handleFileIdsChange = (fileIds) => {
  console.log('File IDs changed:', fileIds);
  // 这里可以根据需要处理文件ID变更，如果需要的话
  // 对于知识库管理，我们可能不需要特殊处理，因为文件信息已在其他地方处理
};
// 处理文件异常
const handleUploadError = (data) => {
  console.log(data); 
};
// 暴露方法给父组件
defineExpose({
  resetFields
});
</script>

<style scoped>
.slider-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.slider-value {
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
}
</style>